
  import { defineComponent } from 'vue';
  import { Icon } from '@/ui/components/icon/Icon';

  interface ContextProps {
    breadcrumb: Array<string>;
    inspectionTitle: string;
    formItemTitle: string;
  }

  export default defineComponent<ContextProps>({
    name: 'Context',
    components: {
      Icon,
    },
    props: ['breadcrumb', 'inspectionTitle', 'formItemTitle'],
    setup() {
      const getIcon = (itemType: 'page'|'section'|'question') => {
        switch (itemType) {
          case 'page':
            return 'file';
          case 'section':
            return 'list-alt';
          default:
            return 'check-square';
        }
      };
      return {
        getIcon,
      };
    },
  });
